import isPlainObject from 'lodash/isPlainObject';
import mapValues from 'lodash/mapValues';
import isArray from 'lodash/isArray';
import map from 'lodash/map';

export default function deeply(m) {
  return function(obj, fn) {
    return m(mapValues(obj, v => {
      if (isPlainObject(v)) {
        return deeply(m)(v, fn);
      }
      if (isArray(v)) {
        return map(v, (v2) => (isPlainObject(v2) || isArray(v2)) ? deeply(m)(v2, fn) : v2);
      }
      return v;
    }), fn);
  };
}



// WEBPACK FOOTER //
// ./src/utils/deeply.util.js